function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.195c4.29 0 7.836-3.547 7.836-7.836 0-4.296-3.547-7.836-7.844-7.836C3.703.523.164 4.063.164 8.36c0 4.29 3.547 7.836 7.836 7.836zm-2.781-4.547a.5.5 0 01-.508-.5.49.49 0 01.156-.359l2.414-2.422-2.414-2.422a.491.491 0 01.352-.851c.14 0 .258.047.36.156l2.413 2.414 2.438-2.422a.497.497 0 01.86.336c0 .14-.048.25-.15.367L8.71 8.367l2.423 2.414c.101.11.148.227.148.367 0 .282-.219.5-.508.5a.522.522 0 01-.367-.156L7.992 9.078l-2.398 2.414a.508.508 0 01-.375.156z",
  fill: "#CFD8DF"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.be155948.svg";
export { ForwardRef as ReactComponent };